// extracted by css-extract-rspack-plugin
export default {"moduleIcon":"moduleIcon-kU95Ar"};